import React from 'react';
import './connection-creator.css';
import rest from './rest.png';
import ex10 from './e2010.png';
import exchange from './exchange.png';
import htmlImg from './html.png';
import soap from './soap.png';
import sqlImg from './sql.png';
import HttpConnector from './http-connector/HttpConnector';
import SoapConnector from './soap-connector/SoapConnector';
import HtmlConnector from './html-connector/HtmlConnector';
import ExchangeConnector from './exchange-connector/ExchangeConnector';
import ExchangeWebServiceConnector from './exchangewebservice-connector/ExchangeWebServiceConnector';
import SqlConnector from './sql-connector/SqlConnector';
import ComponentWithMemory from '../../../supers/ComponentWithMemory';
class ConnectionCreator extends ComponentWithMemory {
	constructor(props) {
		super(props);
		this.data = {
			selected: null,
			stepKey: Math.random()
		};
	}

	onTypeClick = evt => {
		this.observe(() => {
			this.data.stepKey = Math.random();
			this.data.selected = evt.currentTarget.dataset.type;
		});
	};

	getTypeImage = type => {
		switch (type) {
			case 'REST': {
				return rest;
			}
			case 'SOAP': {
				return soap;
			}
			case 'HTML': {
				return htmlImg;
			}
			case 'EXCHANGE 2010': {
				return exchange;
			}
			case 'EXCHANGE': {
				return ex10;
			}
			case 'SQL': {
				return sqlImg;
			}
			default: {
				return '';
			}
		}
	};

	buildConnTypes = () => {
		let items = [];
		let types = ['REST', 'SOAP', 'HTML', 'EXCHANGE', 'EXCHANGE 2010', 'SQL'];
		for (let i = 0; i < types.length; i++) {
			let type = types[i];
			let selected = type === this.data.selected ? 'selected' : '';
			items.push(
				<div
					className={`conn-type shadow hover vbox hcenter vcenter ${selected}`}
					data-type={type}
					onClick={this.onTypeClick}
					key={type.split(' ').join('') + '-type-key'}
				>
					<img className="type-photo" src={this.getTypeImage(type)} alt="Connection Type" />
				</div>
			);
		}
		return items;
	};

	buildStepHeader = () => {
		let subText = {
			REST: 'Connect to any HTTP based web service using this API.',
			SOAP: 'Connect to any SOAP based web service using this API.',
			HTML: 'The HTML connector lets you scrape and extract data from websites to consume it as a REST api.',
			EXCHANGE:
				'Interact with your Exchange 2007/2010 server via the Exchange Web Services (EWS) to access and manage mailbox data. EWS ' +
				'provides the functionality to enable client applications to communicate with the Exchange server. EWS provides access to much of the' +
				' same data that is made available through Microsoft OfficeOutlook. EWS clients can integrate Outlook data into Line-of-Business (LOB)' +
				' applications. SOAP provides the messaging framework for messages sent between the client application and the Exchange server. ' +
				'The SOAP messages are sent by HTTP.',
			SQL: 'Connect to any SQL based web service using this API.',
			'EXCHANGE 2010': 'Interact with your Exchange 2007 server via the Exchange Web Services to access and manage mailbox data.'
		};
		return (
			<div className="step-header animated fadeInDown" key={this.data.stepKey + '-header'}>
				<h3>2. Configure your new connection</h3>
				<div className="sub-text">{subText[this.data.selected]}</div>
				{this.data.selected.indexOf('EXCHANGE') >= 0 && (
					<div className="doc-link">
						Read the{' '}
						<a href="https://msdn.microsoft.com/en-us/library/dd877302(v=exchg.140).aspx" target="_blank" rel="noopener noreferrer">
							official Exchange documentation
						</a>{' '}
						for further information about this service.
					</div>
				)}
			</div>
		);
	};

	buildStepCard = () => {
		switch (this.data.selected) {
			case 'REST': {
				return <HttpConnector />;
			}
			case 'SOAP': {
				return <SoapConnector />;
			}
			case 'HTML': {
				return <HtmlConnector />;
			}
			case 'EXCHANGE 2010': {
				return <ExchangeConnector />;
			}
			case 'EXCHANGE': {
				return <ExchangeWebServiceConnector />;
			}
			case 'SQL': {
				return <SqlConnector />;
			}
			default: {
				return '';
			}
		}
	};

	render() {
		let { selected } = this.data;
		return (
			<div className="connection-creator-view animated fadeIn">
				<div className="main-content">
					<div className="step">
						<div className="step-header">
							<h3>1. Select a connection type</h3>
							<div className="sub-text">The platform offers all of these connectors to easily connect to your data access APIs.</div>
						</div>
						<div className="step-text">Which service would you like to connect to?</div>
						<div className="type-options hbox vcenter hcenter">{this.buildConnTypes()}</div>
					</div>
					{selected && (
						<div className="step">
							{this.buildStepHeader()}
							{this.buildStepCard()}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default ConnectionCreator;



// WEBPACK FOOTER //
// ./src/views/connections-panel/connection-creator/ConnectionCreator.js